<template>
  <input id="fileInput" type="file" @change="upload" />
</template>

<script>
import Papa from 'papaparse';

export default {
  name: 'SchoolImport',
  components: { Papa },
  props: [],
  data() {
    return {
      schools: null,
    };
  },
  methods: {
    upload(ev) {
      const that = this;
      const fileToLoad = ev.target.files[0];
      const reader = new FileReader();
      reader.onload = (fileLoadedEvent) => {
        Papa.parse(fileLoadedEvent.target.result, {
          header: true,
          keepEmptyRows: false,
          skipEmptyLines: true,
          complete(results) {
            // eslint-disable-next-line arrow-parens
            that.schools = results.data.map((school) => ({
              RollNumber: school['Roll Number'],
              Name: school['Official School Name'],
              Address1: school['Address 1'],
              Address2: school['Address 2'],
              Address3: school['Address 3'],
              Address4: school['Address 4'],
              County: school.County,
              LocalAuthority: school['Local Authority'],
              Eircode: school.Eircode,
              EmailAddress: school.Email,
              AvailableLanguages: ['en', 'ga'],
              DefaultLanguage: 'en',
              TotalStudentCount:
                (Number(school.MALE.replace(',', '')) || 0) +
                (Number(school.FEMALE.replace(',', '')) || 0),
            }));
            that.$emit('imported');
          },
          error() {},
        });
      };
      reader.readAsText(fileToLoad);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/SchoolImport.vue